import React, { useEffect } from 'react';
import { Switch, Route, Redirect, useParams, useHistory, useRouteMatch } from 'react-router-dom';

import { useCourseContext } from '@ts-core/context/course';

import courseRoutes from 'modules/courses/routes';

import { useCourse } from 'modules/courses/hooks';

const CoursePage = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const { setCourse } = useCourseContext();

  const { courseId } = useParams();
  const { academyHasFeatures, course, loading } = useCourse({ courseId });

  useEffect(() => {
    setCourse(course);
  }, [course, setCourse]);

  if (!courseId) {
    history.replace('/courses');
    return null;
  }

  if (loading) {
    return <div />;
  }

  return (
    <Switch>
      {courseRoutes
        .filter((route) => academyHasFeatures(route.requiredFeatures))
        .map((route, index) => (
          <Route key={index} path={`${path}${route.path}`} exact={route.exact} component={route.component} />
        ))}
      <Redirect to="/courses" />
    </Switch>
  );
};

export default CoursePage;
